import {createInviteField, createInviteFieldValidation} from 'constants/FormField/createInviteField'
import useFromFieldWithAccount from 'logic/useFromFieldWithAccount'

const useInvites = () => {
    const {fieldsCreate, fieldsEdit, isLoading, validationSchema} = useFromFieldWithAccount({
        fieldsCreate: createInviteField,
        fieldsEdit: createInviteField,
        validationSchema: createInviteFieldValidation,
    })

    return {
        fieldsCreate,
        fieldsEdit,
        isLoading,
        validationSchema,
    }
}

export default useInvites
